import React from "react";
import PropTypes from "prop-types";

export const SelfHeader = ({ userName = "", learnerCode = "" }) => {
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  return (
    <section className="sl-hero">
      <div className="sl-hero__inner">
        <h1 className="sl-hero__greet">
          {getGreeting()}
          {userName ? `, ${userName}` : ""} <span className="wave">&#128075;</span>
        </h1>
        <p className="sl-hero__sub">Here is where you stand and what to do next.</p>
        {learnerCode && (
          <span className="sl-chip">
            <i className="fas fa-id-badge" /> Learner ID: {learnerCode}
          </span>
        )}
      </div>
    </section>
  );
};

SelfHeader.propTypes = {
  userName: PropTypes.string,
  learnerCode: PropTypes.string,
};
